<template>
  <div class="actions-block">
      <div class="action-label">
          ACTIONS
      </div>

      <ActionWidget action_id="find_water" :player="player" />
      <ActionWidget action_id="find_food" :player="player" />
      <ActionWidget action_id="find_wood" :player="player" />
      <ActionWidget action_id="find_stone" :player="player" />
  </div>
</template>

<script>

import ProgressBar from './ui/ProgressBar'
import ActionWidget from './ui/ActionWidget'

export default {
  name: 'Actions',
  components: { ProgressBar, ActionWidget },
  methods: {
  },
  computed: {
    player: {
      get () {
        return this.$store.state.player
      }
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Actions.vue